import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Service } from '../types';
import { useServices } from '../hooks/useApi';

interface ServicesProps {
  onServiceSelect: (service: Service) => void;
}

const ServicesSection: React.FC<ServicesProps> = ({ onServiceSelect }) => {
  const { services, loading, error, fetchServices } = useServices();

  useEffect(() => {
    fetchServices();
  }, []);

  const getServiceIcon = (serviceName: string) => {
    const name = serviceName || '';
    if (name.includes('Wash')) return '🚿';
    if (name.includes('Denting')) return '🔧';
    if (name.includes('Battery')) return '🔋';
    if (name.includes('Mechanical')) return '⚙️';
    if (name.includes('AC')) return '❄️';
    if (name.includes('Clutch')) return '⚡';
    if (name.includes('Lights')) return '💡';
    if (name.includes('Regular')) return '🛠️';
    if (name.includes('Suspension')) return '🚗';
    if (name.includes('Tyre')) return '⭕';
    if (name.includes('Polishing')) return '⭐';
    if (name.includes('Inspections')) return '🔍';
    return '🔧';
  };

  if (loading) {
    return (
      <section id="services" className="py-5 bg-light">
        <Container>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  if (error) {
    return (
      <section id="services" className="py-5 bg-light">
        <Container>
          <div className="text-center text-danger">
            <p>Error loading services: {error}</p>
          </div>
        </Container>
      </section>
    );
  }

  return (
    <section id="services" className="py-5 bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold text-dark mb-3">Our Services</h2>
          <p className="lead text-muted mb-4">
            Comprehensive automobile repair and maintenance services for all car brands
          </p>
        </div>

        <Row>
          {services.map((service) => (
            <Col lg={4} md={6} className="mb-4" key={service.id}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body className="d-flex flex-column">
                  <div className="d-flex align-items-center mb-3">
                    <div className="display-6 me-3 text-primary">
                      {getServiceIcon(service.title || service.service_name || '')}
                    </div>
                    <div>
                      <h5 className="card-title mb-1">{service.title || service.service_name}</h5>
                      <div className="text-success fw-bold">
                        ₹{service.price || service.starting_price}+ {service.unit || 'per service'}
                      </div>
                    </div>
                  </div>
                  <p className="card-text text-muted flex-grow-1">
                    {service.description}
                  </p>
                  <Button 
                    variant="primary" 
                    className="w-100 fw-semibold mt-auto"
                    onClick={() => onServiceSelect(service)}
                  >
                    Book This Service
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;